import { render, staticRenderFns } from "./external_sendpulse.vue?vue&type=template&id=540df73f&scoped=true&"
import script from "./external_sendpulse.vue?vue&type=script&lang=js&"
export * from "./external_sendpulse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540df73f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540df73f')) {
      api.createRecord('540df73f', component.options)
    } else {
      api.reload('540df73f', component.options)
    }
    module.hot.accept("./external_sendpulse.vue?vue&type=template&id=540df73f&scoped=true&", function () {
      api.rerender('540df73f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/sendpulse/external_sendpulse/external_sendpulse.vue"
export default component.exports